import { useSuspenseQuery } from "@tanstack/react-query";
import { linkOptions, useRouterState } from "@tanstack/react-router";
import { useMemo } from "react";

import { useTRPC } from "@/integrations/trpc/react";

export function useVenueFilterOptions(link?: boolean) {
  const trpc = useTRPC();
  const { location } = useRouterState();

  const { data: venues } = useSuspenseQuery({
    ...trpc.venues.list.queryOptions(),
    select: (data) =>
      data.map(({ id, name, city }) => ({
        value: id,
        display: `${name}, ${city}`,
      })),
  });

  return useMemo(
    () =>
      venues.map((v) => ({
        ...v,
        link: link
          ? linkOptions({
              to: location.pathname,
              search: (search) => {
                const values = search.venues ?? [];
                return {
                  ...search,
                  page: 1,
                  venues: values.includes(v.value)
                    ? values.filter((id) => id !== v.value)
                    : values.concat(v.value),
                };
              },
            })
          : undefined,
      })),
    [venues, link, location.pathname],
  );
}
